var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPixverse = function SvgPixverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.934 47.675 9 42.03V11.14c0-1.468.638-3.095 1.67-4.133l2.76-2.773 12.063 39.458c.848 2.755-1.963 5.211-4.56 3.983Z",
    fill: "url(#pixverse_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.569 16.86 23.957 1.81a5.482 5.482 0 0 0-7.96-.19L10.67 7.007C9.654 8.175 9.073 9.403 9.073 10.87v30.89l27.255-16.437c2.977-1.796 3.576-5.88 1.24-8.463Z",
    fill: "url(#pixverse_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pixverse_svg__a",
    x1: -30.06,
    y1: 7.487,
    x2: 7.968,
    y2: 66.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#E470EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pixverse_svg__b",
    x1: 30.749,
    y1: 10.791,
    x2: -7.4,
    y2: 47.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#E36CFA",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442FBA",
    stopOpacity: 0.7
  })))));
};
export default SvgPixverse;